module.exports = {
      id: "plus-dark-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#plus-dark",
      toString: function () {
        return this.url;
      }
    }